import React, { useEffect, useMemo, useRef, useState } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Oval, ThreeDots } from "react-loader-spinner";
import { confirmDialog } from "primereact/confirmdialog";

import { Button, DropDownField, TextInputField } from "../../../../helpers";

import Loading from "../../../../common/Loading";
import CopyToClipboard from "../../../../common/CopyToClipboard";

import ProductsListItems from "./productsListItems";
import DisplaySellerPO from "./DisplaySellerPO";
import StructuredMaterialsConfirmModal from "./StructuredMasterialsConfirmModal";

import { getPOPunchByBuyerPOId } from "../../../../services/api/poPunch";
import { getSellerPOItemsBySellerPOIds } from "../../../../services/api/sellerPOItem";
import { getBuyerPOItemsByBuyerPOIds } from "../../../../services/api/buyerPOItem";
import { getSellerReqItemBySellerReqIds } from "../../../../services/api/sellerReqItem";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../../../services/api/buyerReqItem";
import { checkMaterialsAreInMaterialSpecs, updateAssigneeCentralUserIdAndPriorityStatus } from "../../../../services/api/materialMasterTemp";
import { getMaterialIDTeamNames, getPastSellerPOMaterialTransactions, getPastSellerPOsByCompanyIds, getSellerPOByBuyerPOIds, getSellerPOsRaw } from "../../../../services/api/sellerPO";
import { getCompanyBranchShipAddrDataByShipAddrIds } from "../../../../services/api/companyBranchShipAddr";
import { getApprovalInstances } from "../../../../services/api/approvalInstances";
import { getBuyerQuoteItems } from "../../../../services/api/buyerQuoteItem";
import { getCompanyBillAddrs } from "../../../../services/api/companyBillAddr";
import { getStockDocsByDocNos } from "../../../../services/api/stockDoc";
import { getAdjustmentNoteItemsBySellerPOItemIds } from "../../../../services/api/adjustmentNoteItems";
import { getMaterialsInStock, getSellerDetailsBySellerReqs, insertUseFromStockSellerReq } from "../../../../services/api/sellerReq";
import { getSmartStockMovesByWarehouseIdAndMaterialIdCombination } from "../../../../services/api/smartStockMoves";
import { fetchApprovals, fetchCompanyCreditPeriods, fetchHSNMasterData, fetchIncoTerms, fetchPMBranches, fetchStates, fetchTDSSections, fetchVendorRateContracts } from "../../../../services/redux/reducers/commonThunk";
import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { setSelectedBuyerPODocNo } from "../../../../services/redux/reducers/Requirement/requirement";
import { fetchMaterialBrands, fetchMaterialCategories, fetchMaterialSpecifications } from "../../../../services/redux/reducers/commonThunk";
import { getMaterialIdTeamData } from "../../../../services/api/materialIdTeam";
import { searchMaterialMandatoryUseFromStock } from "../../../../services/api/materialMandatoryUseFromStock";

import { calculateStockGSTAndPrice, getDateString, getDateTimeString, getFullName, round } from "../../../../utils";
import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";
import { stockDocParser, stockWarehousesParser } from "../../../../parserFunctions";
import { getCompanyBankAccounts } from "../../../../services/api/companyBankAccount";
import { getCompanyCertificates } from "../../../../services/api/companyCertificates";


const CreateSellerPO = (props) => {
    const { sellerReqData, buyerPOData, selectedReq, setIsPageLoading, sellerPOData, visibleCreateSellerPO, setVisibleCreateSellerPO } = props

    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [buyerPO, setBuyerPO] = useState({})
    const [buyerPOPunchItems, setBuyerPOPunchItems] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [sellerReqs, setSellerReqs] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [initialSellerReqItems, setInitialSellerReqItems] = useState([])
    const [tempMaterialIds, setTempMaterialIds] = useState([])
    const [tempMaterialItems, setTempMaterialItems] = useState([])
    const [materialTeamNames, setMaterialTeamNames] = useState('')
    const [buyerPOOptions, setBuyerPOOptions] = useState([])
    const [buyerShipAddrs, setBuyerShipAddrs] = useState([])
    const [procmartShipAddrs, setProcMartShipAddrs] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState([])
    const [allMaterialDetails, setAllMaterialDetails] = useState([])
    const [initialMaterialDetails, setInitialMaterialDetails] = useState([])
    const [materialEditStatus, setMaterialEditStatus] = useState([])
    const [procmartCompanyBillAddrs, setProcmartCompanyBillAddrs] = useState([])
    const [statesData, setStatesData] = useState([])
    const [displaySellerPOs, setDisplaySellerPOs] = useState([])
    const [displaySellerPOItems, setDisplaySellerPOItems] = useState([])
    const [approvalInstances, setApprovalInstances] = useState([])
    const [pastSellerPOMaterialTransactions, setPastSellerPOMaterialTransactions] = useState([])
    const [pastSellerPOsInfo, setPastSellerPOsInfo] = useState([])
    const [nonRoutedSellerPOsInfo, setNonRoutedSellerPOsInfo] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])
    const [prevSellerPOs, setPrevSellerPOs] = useState([])
    const [companyCertificates, setCompanyCertificates] = useState([])

    const [isCreateSellerPOLoading, setIsCreateSellerPOLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [quoteDetails, setQuoteDetails] = useState({})
    const [isStockLoading, setIsStockLoading] = useState(false)
    const [isStockVisible, setIsStockVisible] = useState(false)
    const [visibleMaterialMessages, setVisibleMaterialMessages] = useState(false)

    const [stockMaterials, setStockMaterials] = useState([])
    const [selectedBuyerPOItem, setSelectedBuyerPOItem] = useState({})
    const [selectedStockWarehouse, setSelectedStockWarehouse] = useState({})
    const [isStockDetailsVisible, setIsStockDetailsVisible] = useState(false)
    const [smartStockMoves, setSmartStockMoves] = useState([])
    const [oldSellerReqItems, setOldSellerReqItems] = useState([])
    const [buyerPoCreatedAtDate, setBuyerPoCreatedAtDate] = useState(false)

    const [materialSpecsMatchesData, setMaterialSpecsMatchesData] = useState([])
    const [isMaterialSpecsConfirmModalVisible, setIsMaterialSpecsConfirmModalVisible] = useState(false)
    const [materialIdTeam, setMaterialIdTeam] = useState([])
    const [sellerBankAccounts, setSellerBankAccounts] = useState([])

    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)
    const selectedBuyerPODocNo = useSelector(state => state.requirements.selectedBuyerPODocNo)
    const incoTerms = useSelector((state) => state.common.incoTerms)
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const brandData = useSelector((state) => state.common.materialBrands)
    const companyWarehouses = useSelector(state => state.userDetails.PMCompanyDetails.companyWarehouses)
    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const statesDetails = useSelector((state) => state.common.states)
    const userDetails = useSelector(state => state.userDetails)
    // const materialIdTeam = useSelector(state => state.common.materialIdTeam)
    const tdsSections = useSelector(state => state.common.tdsSections)
    const materialSpecifications = useSelector(state => state.common.materialSpecifications)
    const PMCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const PMBranches = useSelector(state => state.common.PMBranches)
    const approvals = useSelector((state) => state.common.approvals)

    let materialMasterApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => [15].includes(eachApproval.approvalTypeId))
    }, [approvals])

    const dispatch = useDispatch()

    const tempMaterialIDsMsgs = useRef(null)

    useEffect(() => {
        return () => {
            dispatch(setSelectedBuyerPODocNo(null))
        }
    }, [])

    useEffect(() => {
        if (buyerPOOptions && selectedBuyerPODocNo) {
            const getSelectedFormatedDocNo = buyerPOOptions?.find(each => each?.docNo == selectedBuyerPODocNo)
            const buyerPoCreatedDate = getSelectedFormatedDocNo?.createdAt
            setBuyerPoCreatedAtDate(buyerPoCreatedDate)
        }
    }, [buyerPOOptions, selectedBuyerPODocNo])

    useEffect(() => {
        dispatch(fetchPMBranches())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchHSNMasterData())
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchStates())
        // dispatch(fetchMaterialIdTeam())
        dispatch(fetchIncoTerms())
        dispatch(fetchApprovals())
        dispatch(fetchTDSSections())
        dispatch(fetchMaterialSpecifications())
        dispatch(fetchVendorRateContracts())
        if (selectedBuyerPODocNo && companyWarehouses.length && PMBranches.length) {
            constructBuyerPOAndSellerReq(sellerReqData, buyerPOData, selectedReq, selectedBuyerPODocNo)
        }
        getMaterialIdTeam()
    }, [selectedBuyerPODocNo, companyWarehouses, PMBranches])

    useEffect(() => {
        if (statesDetails?.length > 0) {
            getProcmartStates()
        }
    }, [statesDetails, pmCompanyDetails])

    useEffect(() => {
        let filteredBuyerPOs = buyerPOData?.buyerPOs?.filter(eachBuyerPO => eachBuyerPO.buyerReqId === selectedReq.buyerReqId)
        filteredBuyerPOs = filteredBuyerPOs?.filter(eachBuyerPO => eachBuyerPO?.statusId === 3)

        const uniqueBuyerPODocNos = _.compact(filteredBuyerPOs?.map(eachBuyerPO => {
            return {
                docNo: eachBuyerPO.docNo,
                createdAt: eachBuyerPO.createdAt,
                formatedDocNo: `${eachBuyerPO?.docNo} (${getDateString(eachBuyerPO?.createdAt)})`
            }
        }))

        if (uniqueBuyerPODocNos.length === 1) {
            dispatch(setSelectedBuyerPODocNo(uniqueBuyerPODocNos[0].docNo))
        }

        setBuyerPOOptions(uniqueBuyerPODocNos)

    }, [buyerPOData, sellerReqData, selectedReq])

    // useEffect(() => {
    //     getStockWarehouses()
    //     getSmartStockMoves()
    // }, [buyerPOItems, sellerReqItems, sellerReqs, PMBranches])

    useEffect(() => {
        if (tempMaterialIDsMsgs.current) {
            tempMaterialIDsMsgs.current.clear()
            if (tempMaterialIds.length > 0) {
                tempMaterialIDsMsgs.current.replace([{
                    sticky: true, severity: 'error', summary: '', content: renderMessageHTML(tempMaterialItems, materialTeamNames, allMaterialDetails)
                }])
            }
        }
    }, [allMaterialDetails])

    useEffect(() => {
        const lowPriorityMaterials = tempMaterialItems.filter(eachMaterial => eachMaterial.priority !== 1)
        if (lowPriorityMaterials.length) {
            let materialItems = lowPriorityMaterials.map(eachMaterial => ({
                materialId: eachMaterial.materialId,
                productName: eachMaterial.productName,
                variantName: eachMaterial.variantName || '',
                categoryId: eachMaterial.categoryId
            }))

            if (materialItems.length) {
                handleCheckMaterialsAreInMaterialSpecs(materialItems)
            }
        }
    }, [tempMaterialItems])

    const getMaterialIdTeam = async() => {
        setIsLoading(true)
        const response = await getMaterialIdTeamData({paginator: false})
        setIsLoading(false)
        if (response.failure){
            return dispatch(raiseToast({severity:'error', detail: response.data.error , life: 3000}))
        }
        setMaterialIdTeam(response.data)
    }

    const getAvailableQtyForBuyerPOItems = (poPunchItems, sellerPOItems, buyerPOItems, sellerPOStockDocs, adjustmentNoteItems) => {
        let updatedBuyerPOItems = []
        buyerPOItems.forEach(eachBuyerPOItem => {
            const relatedPOPunchItems = poPunchItems.filter(eachPOPunchItem => {
                return eachPOPunchItem.buyerPOItemId === eachBuyerPOItem.buyerPOItemId && eachPOPunchItem.statusId === 1
            })
            const totalPunchedQty = _.sumBy(relatedPOPunchItems, 'punchQty')

            const relatedSellerPOItems = sellerPOItems.filter(eachSellerPOItem => {
                return eachSellerPOItem.buyerPOItemId === eachBuyerPOItem.buyerPOItemId && eachSellerPOItem.statusId === 3
            })
            const sellerPOQty = _.sumBy(relatedSellerPOItems, 'qty')

            const relatedSellerPOStockDocs = sellerPOStockDocs.filter(eachStockDoc => {
                return eachStockDoc.materialId === eachBuyerPOItem.materialId && eachStockDoc.statusId === 1 && eachStockDoc.CNDNQty
            })
            const CNDNQty = _.sumBy(relatedSellerPOStockDocs, 'CNDNQty')

            const relatedAdjustmentNoteItems = adjustmentNoteItems.filter(eachAdjustmentItem => {
                return eachAdjustmentItem.buyerPOItemId === eachBuyerPOItem.buyerPOItemId
            })
            const AdjustedCNQty = _.sumBy(relatedAdjustmentNoteItems, 'adjustedQty')
            
            if (totalPunchedQty - sellerPOQty - CNDNQty + AdjustedCNQty > 0 && eachBuyerPOItem.statusId === 3) {
                updatedBuyerPOItems.push({ ...eachBuyerPOItem, availableQty: totalPunchedQty - sellerPOQty - CNDNQty + AdjustedCNQty })
            }
        })

        return updatedBuyerPOItems
    }

    const constructBuyerPOAndSellerReq = async (sellerReqData, buyerPOData, selectedReq, buyerPODocNo) => {
        //create temp variables
        setIsCreateSellerPOLoading(true)

        const relatedBuyerPO = buyerPOData?.buyerPOs?.find(eachPO => eachPO.docNo === buyerPODocNo)
        setBuyerPO(relatedBuyerPO)

        const buyerPOItemsRes = await getBuyerPOItemsByBuyerPOIds([relatedBuyerPO.buyerPOId])
        if (buyerPOItemsRes?.failure) {
            setIsCreateSellerPOLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: "Buyer PO Items", detail: buyerPOItemsRes?.data?.error, life: 3000 }))
        }

        let updatedBuyerPOItems = buyerPOItemsRes.data.map(eachBuyerPOItem => {
            return {
                buyerPOItemId: eachBuyerPOItem.buyerPOItemId,
                buyerPOId: eachBuyerPOItem.buyerPOId,
                buyerReqId: eachBuyerPOItem.buyerReqId,
                buyerReqItemId: eachBuyerPOItem.buyerReqItemId,
                fileNo: eachBuyerPOItem.fileNo,
                docNo: eachBuyerPOItem.docNo,
                printedDesc: eachBuyerPOItem.printedDesc,
                materialId: eachBuyerPOItem.materialId,
                companyERPCode: eachBuyerPOItem.companyERPCode,
                bPOQty: eachBuyerPOItem.bPOQty,
                bPOListPrice: eachBuyerPOItem.bPOListPrice,
                bPOUnitPrice: eachBuyerPOItem.bPOUnitPrice,
                bPOGSTRate: eachBuyerPOItem.bPOGSTRate,
                bPOHSNCode: eachBuyerPOItem.bPOHSNCode,
                buyerRateContractId: eachBuyerPOItem.buyerRateContractId,
                shipsFromAddrId: eachBuyerPOItem.shipsFromAddrId,
                pmCompanyId: eachBuyerPOItem.pmCompanyId,
                leadTime: eachBuyerPOItem.leadTime,
                bPOItemAmountBeforeTax: eachBuyerPOItem.bPOItemAmountBeforeTax,
                bPOItemAmountWithTax: eachBuyerPOItem.bPOItemAmountWithTax,
                statusId: eachBuyerPOItem.statusId,
                availableQty: null
            }
        })

        if (relatedBuyerPO){
            const buyerQuoteItemRes = await getBuyerQuoteItems({buyerQuoteIds: [relatedBuyerPO?.buyerQuoteId], paginator: false})
            if (buyerQuoteItemRes?.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Buyer Quote Items", detail: buyerQuoteItemRes?.data?.error, life: 3000 }))
            }

            setBuyerQuoteItems(buyerQuoteItemRes?.data?.data)
        }

        if (updatedBuyerPOItems?.length > 0) {
            //Update buyer po item with available qty
        
            const poPunchres = await getPOPunchByBuyerPOId(relatedBuyerPO.buyerPOId)
            if (poPunchres.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'PO Punch', detail: poPunchres.data.error, life: 3000 }))
            }

            setBuyerPOPunchItems(poPunchres?.data?.poPunchItems)

            //const buyerReqItemIds = updatedBuyerPOItems.map(eachPOItem => eachPOItem.buyerReqItemId)
            const poPunchItems = poPunchres?.data?.poPunchItems

            if(!poPunchItems.length){
                setIsCreateSellerPOLoading(false)
                setSellerReqItems([])
                setInitialSellerReqItems([])
                return 
            }

            const tempMaterialIds = []
            const materialIds = []

            poPunchItems.forEach(eachPOPunchItem => {
                const relatedBuyerPOItem = updatedBuyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachPOPunchItem.buyerPOItemId)
                if (relatedBuyerPOItem.materialId.toString().length >= 7) {
                    tempMaterialIds.push(relatedBuyerPOItem.materialId)
                } else {
                    materialIds.push(relatedBuyerPOItem.materialId)
                }
            })

            const buyerReqItemIds = poPunchItems.map(eachPOItem => eachPOItem.buyerReqItemId)
            const materialRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: buyerReqItemIds })
            if (materialRes.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Material IDs", detail: materialRes?.data?.error, life: 3000 }))
            }

            const updatedMaterialDetails = materialRes?.data.map(eachMaterial => {
                return { ...eachMaterial, isEditable: false, buyerReqId: selectedReq.buyerReqId, checkMaterialInAnotherReq: true, brand: eachMaterial.brandId }
            })

            setAllMaterialDetails(updatedMaterialDetails)
            setInitialMaterialDetails(JSON.parse(JSON.stringify(updatedMaterialDetails)))
            setTempMaterialIds(tempMaterialIds)

            const materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
            if(materialMandatoryUseFromStockRes.failure){
                return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
            }

            setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)

            const approverInstancesRes = await getApprovalInstances({materialIds: tempMaterialIds})
            if (approverInstancesRes.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Approval Instance", details: approverInstancesRes.data.error, life: 3000 }))
            }

            setApprovalInstances(approverInstancesRes.data.data)

            const companyIds = sellerReqData.sellerReqs?.map(eachSellerReq => eachSellerReq.companyId)
            const brandIds = updatedMaterialDetails.map(eachMaterial => eachMaterial.brandId)
            const companyCertificatesRes = await getCompanyCertificates({companyIds: companyIds, entityIds: brandIds, entityType: 'Brand'})

            if (companyCertificatesRes.failure){
                return dispatch(raiseToast({ severity: 'error', summary: "Company Certificates", details: companyCertificatesRes.data.error, life: 3000 }))
            }

            setCompanyCertificates(companyCertificatesRes.data.data)

            //get these names from redux
            const materialTeamRes = await getMaterialIDTeamNames()
            if (materialTeamRes.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Material Team deatails", detail: materialTeamRes?.data?.error, life: 3000 }))
            }
            const materialTeamNames = materialTeamRes.data.map(eachMaterial => eachMaterial.concat)
            setMaterialTeamNames(materialTeamNames)

            const tempMaterialItems = updatedMaterialDetails?.filter(eachMaterial => eachMaterial.materialId.toString().length >= 7)
            setTempMaterialItems(tempMaterialItems)

            if (tempMaterialItems.length > 0) {
                setVisibleMaterialMessages(true)
            }
            else {
                setVisibleMaterialMessages(false)
            }

            if (tempMaterialIDsMsgs.current) {
                tempMaterialIDsMsgs.current.clear()
                if (tempMaterialIds.length > 0) {
                    tempMaterialIDsMsgs.current.show([{
                        sticky: true, severity: 'error', summary: '', content: renderMessageHTML(tempMaterialItems, materialTeamNames, allMaterialDetails)
                    }])
                }
            }

            // const categoryIds = updatedMaterialDetails.map(eachMaterial => eachMaterial.categoryId)
            // const materialIDTeamsRes = await searchMaterialIdteams({ accessEntities: categoryIds, accessTypes: ['CATEGORY', 'CENTRAL'] })

            // if (materialIDTeamsRes.failure) {
            //     setIsCreateSellerPOLoading(false)
            //     return dispatch(raiseToast({ severity: 'error', summary: "Material Team deatails", detail: materialIDTeamsRes?.data?.error, life: 3000 }))
            // }
            // setMaterialMasterTempSecondaryApprovers(materialIDTeamsRes.data.data)

            //const updatedSellerPOs = sellerPOData?.sellerPOs?.filter(eachSellerPO => eachSellerPO.buyerPOId === relatedBuyerPO.buyerPOId)

            const sellerPOsResponse = await getSellerPOByBuyerPOIds({buyerPOIds: [relatedBuyerPO.buyerPOId]})
            if (sellerPOsResponse.failure){
                return dispatch(raiseToast({ severity: 'error', summary: "Seller POs", detail: sellerPOsResponse.data.error }))
            }
            
            setPrevSellerPOs(sellerPOsResponse.data)

            const updatedSellerPOs = sellerPOsResponse.data

            const sellerPOIds = updatedSellerPOs?.map(eachSellerPO => eachSellerPO?.sellerPOId)
            const sellerPODocNos = updatedSellerPOs?.map(eachSellerPO => eachSellerPO?.docNo)

            const sellerPOItemsRes = await getSellerPOItemsBySellerPOIds(sellerPOIds)
            if (sellerPOItemsRes?.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Seller PO Items", detail: sellerPOItemsRes?.data?.error, life: 3000 }))
            }
            const relatedSellerPOItems = sellerPOItemsRes.data
            const relatedSellerPOItemsIds = relatedSellerPOItems.map(eachSellerPOItem => eachSellerPOItem.sellerPOItemId)

            let sellerPOStockDocs = []

            const sellerPOStockDocsRes = await getStockDocsByDocNos({ docNos: sellerPODocNos })
            if (sellerPOStockDocsRes?.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Stock docs", detail: sellerPOStockDocsRes?.data?.error, life: 3000 }))
            } else {
                sellerPOStockDocs = sellerPOStockDocsRes.data
            }
            sellerPOStockDocs = stockDocParser(sellerPOStockDocs)

            let adjustmentNoteItems = []
            if(relatedSellerPOItemsIds.length > 0){
                const adjustmentNoteItemRes = await getAdjustmentNoteItemsBySellerPOItemIds({toBeRefilled: true, sellerPOItemIds: relatedSellerPOItemsIds, adjustmentNoteStatusIds: [1], paginator: false})
                if (adjustmentNoteItemRes?.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: "Stock docs", detail: adjustmentNoteItemRes?.data?.error, life: 3000 }))
                } else {
                    adjustmentNoteItems = adjustmentNoteItemRes.data
                }
            }

            updatedBuyerPOItems = getAvailableQtyForBuyerPOItems(poPunchres?.data?.poPunchItems, relatedSellerPOItems, updatedBuyerPOItems, sellerPOStockDocs, adjustmentNoteItems)
            setBuyerPOItems(updatedBuyerPOItems)

           if(updatedBuyerPOItems.length){
            //Update seller req
            const selectedSellerReqs = sellerReqData?.sellerReqs?.filter(eachSellerReq => eachSellerReq.buyerReqId === selectedReq.buyerReqId)
            const updatedSellerReqs = selectedSellerReqs.map(eachSellerReq => {
                return {
                    sellerReqId: eachSellerReq.sellerReqId,
                    buyerReqId: eachSellerReq.buyerReqId,
                    fileNo: eachSellerReq.fileNo,
                    docNo: eachSellerReq.docNo,
                    companyId: eachSellerReq.companyId,
                    branchId: eachSellerReq.branchId,
                    userId: eachSellerReq.userId,
                    createdAt: eachSellerReq.createdAt,
                    updatedAt: eachSellerReq.updatedAt,
                    reminders: eachSellerReq.reminders,
                    numItemsReqSent: eachSellerReq.numItemsReqSent,
                    numItemsQuotRecd: eachSellerReq.numItemsQuotRecd,
                    isURD: eachSellerReq.isURD,
                    paymentTerms: eachSellerReq.paymentTerms,
                    sellerDocNo: eachSellerReq.sellerDocNo,
                    pmCompanyId: eachSellerReq.pmCompanyId,
                    currency: eachSellerReq.currency,
                    currencyRate: eachSellerReq.currencyRate,
                    createdBy: eachSellerReq.createdBy,
                    updatedBy: eachSellerReq.updatedBy,
                    docProof: eachSellerReq.docProof,
                    pmBranchId: eachSellerReq.pmBranchId
                }
            })
            setSellerReqs(updatedSellerReqs)

            const sellerDetailsRes = await getSellerDetailsBySellerReqs({ sellerReqs: updatedSellerReqs })
            if (sellerDetailsRes.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Sellers Names', detail: sellerDetailsRes.data.error, life: 3000 }))
            }
            setSellerCompanyDetails(_.compact(sellerDetailsRes?.data))

            const sellerReqIds = updatedSellerReqs?.map(eachSellerReq => eachSellerReq?.sellerReqId)
            const sellerReqItemsRes = await getSellerReqItemBySellerReqIds(sellerReqIds)
            if (sellerReqItemsRes?.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Seller PO Items", detail: sellerReqItemsRes?.data?.error, life: 3000 }))
            }

            const selectedSellerReqItems = sellerReqItemsRes.data?.filter(eachSellerReqItem => {
                return eachSellerReqItem?.buyerReqId === selectedReq?.buyerReqId && eachSellerReqItem.quotUnitPrice && eachSellerReqItem.statusId === 1
            })

            const selectedAllSellerReqItems = sellerReqItemsRes.data?.filter(eachSellerReqItem => {
                return eachSellerReqItem?.buyerReqId === selectedReq?.buyerReqId
            })

            const updatedSellerReqItems = selectedSellerReqItems.map(eachSellerReqItem => {
                return {
                    sellerReqItemId: eachSellerReqItem.sellerReqItemId,
                    sellerReqId: eachSellerReqItem.sellerReqId,
                    buyerReqId: eachSellerReqItem.buyerReqId,
                    buyerReqItemId: eachSellerReqItem.buyerReqItemId,
                    fileNo: eachSellerReqItem.fileNo,
                    docNo: eachSellerReqItem.docNo,
                    materialId: eachSellerReqItem.materialId,
                    qty: eachSellerReqItem.qty,
                    shipAddrId: eachSellerReqItem.shipAddrId,
                    quotQty: eachSellerReqItem.quotQty,
                    quotListPrice: eachSellerReqItem.quotListPrice,
                    quotDiscountRate: eachSellerReqItem.quotDiscountRate,
                    quotUnitPrice: eachSellerReqItem.quotUnitPrice,
                    originalQuotUnitPrice: eachSellerReqItem.quotUnitPrice,
                    quotHSNCode: eachSellerReqItem.quotHSNCode,
                    quotTotalAmountBeforeTax: eachSellerReqItem.quotTotalAmountBeforeTax,
                    quotGSTRate: eachSellerReqItem.quotGSTRate,
                    quotTotalAmountWithTax: eachSellerReqItem.quotTotalAmountWithTax,
                    quotLeadTime: eachSellerReqItem.quotLeadTime,
                    quotLogisticsBeforeTax: eachSellerReqItem.quotLogisticsBeforeTax,
                    quotLogisticsGSTRate: eachSellerReqItem.quotLogisticsGSTRate,
                    quotLogisticsWithTax: eachSellerReqItem.quotLogisticsWithTax,
                    remarks: eachSellerReqItem.remarks,
                    pmCompanyId: eachSellerReqItem.pmCompanyId,
                    currency: eachSellerReqItem.currency,
                    currencyRate: eachSellerReqItem.currencyRate,
                    createdBy: eachSellerReqItem.createdBy,
                    updatedBy: eachSellerReqItem.updatedBy,
                    statusId: eachSellerReqItem.statusId,
                    createSellerPOQty: null,

                    smartUnitPrice: eachSellerReqItem.quotUnitPrice,
                    smartGSTRate: eachSellerReqItem.quotGSTRate
                }
            })
            setSellerReqItems(updatedSellerReqItems)
            setInitialSellerReqItems(selectedAllSellerReqItems)

            let sellerReqItemsRelatedShipAddrsIds = []
            sellerReqItemsRes?.data?.map(eachSellerReqItem => {
                const relatedWarehouse = companyWarehouses?.find(eachCompanyWarehouse => eachCompanyWarehouse?.shipAddrId === eachSellerReqItem?.shipAddrId)
                if (relatedWarehouse?.warehouseId) {
                    sellerReqItemsRelatedShipAddrsIds.push(relatedWarehouse?.shipAddrId)
                }
            })

            const shipAddrsRes = await getCompanyBranchShipAddrDataByShipAddrIds({ shipAddrIds: [selectedReq?.shipAddrId, ...sellerReqItemsRelatedShipAddrsIds] })
            if (shipAddrsRes?.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Shipping Address", detail: shipAddrsRes?.data?.error, life: 3000 }))
            }

            let buyerShipAddrs = []
            let procmartShipAddrs = []
            shipAddrsRes?.data?.map(eachShipAddr => {
                if (eachShipAddr?.shipAddrId === selectedReq?.shipAddrId) {
                    buyerShipAddrs.push(eachShipAddr)
                } else {
                    procmartShipAddrs.push(eachShipAddr)
                }
            })

            setBuyerShipAddrs(buyerShipAddrs)
            setProcMartShipAddrs(procmartShipAddrs)

            const companyIds = selectedSellerReqs.map(eachSellerReq => eachSellerReq.companyId)
            await getSellerBankAccounts({companyIds, paginator: false})
            const pastSellerPOsRes = await getPastSellerPOsByCompanyIds({companyIds: companyIds, pastSellerPOsRequired: true})
    
            if (pastSellerPOsRes.failure){
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Past Seller POs", detail: pastSellerPOsRes.data.error, life: 3000 }))
            }
    
            setPastSellerPOsInfo(pastSellerPOsRes.data.pastSellerPOsInfo)
            setNonRoutedSellerPOsInfo(pastSellerPOsRes.data.nonRoutedSellerPOsInfo)

            await getStockWarehouses(updatedBuyerPOItems)
            const smartStockMoves = await getSmartStockMoves(updatedSellerReqs, updatedSellerReqItems)
            let updatedSmartStockMoves = []
            if(smartStockMoves){
                updatedSmartStockMoves = [...smartStockMoves]
            }
            setSmartStockMoves(updatedSmartStockMoves)
            await getMaterialPastTransactions(updatedBuyerPOItems, updatedSellerReqItems)
            setIsCreateSellerPOLoading(false)
           }
           setIsCreateSellerPOLoading(false)
        }
    }

    const getSellerBankAccounts = async(data) => {
        setIsLoading(true)
        const sellerBankAccountResponse = await getCompanyBankAccounts(data)
        console.log("sellerBankAccountResponse", sellerBankAccountResponse)
        setIsLoading(false)
        if(sellerBankAccountResponse.failure){
            dispatch(raiseToast({ severity: 'error', summary: 'Seller Bank Accounts', detail: sellerBankAccountResponse.data.error, life: 3000 }))
        }
        let sellerBankAccounts = sellerBankAccountResponse.data.data
        setSellerBankAccounts([...sellerBankAccounts])
    }

    const getMaterialPastTransactions = async (updatedBuyerPOItems, updatedSellerReqItems) => {
        let materialIdAndWarehouseIdCombinations = updatedBuyerPOItems.map(eachBuyerPOItem => {
            if(updatedSellerReqItems.length){
                const relatedSellerReqItem = updatedSellerReqItems.find(eachSellerReqItem => eachBuyerPOItem.materialId === eachSellerReqItem.materialId)
                if(relatedSellerReqItem){
                    const relatedCompanyWarehouse = companyWarehouses.find(eachCompanyWarehouse => eachCompanyWarehouse.shipAddrId === relatedSellerReqItem.shipAddrId)
                    if(relatedCompanyWarehouse){
                        return {
                            materialId: eachBuyerPOItem.materialId,
                            warehouseId: relatedCompanyWarehouse.warehouseId
                        }
                    }
                }
            }
            return {
                materialId: eachBuyerPOItem.materialId,
                warehouseId: selectedReq.pmWarehouseId
            }
        })

        const pastSellerPOMaterialtransactiosRes = await getPastSellerPOMaterialTransactions({ materialIdAndWarehouseIdCombinations, pmBranchId: selectedReq.pmBranchId })
        if (pastSellerPOMaterialtransactiosRes.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'Past Seller PO Material Transactions', detail: pastSellerPOMaterialtransactiosRes.data.error }))
        }
        setPastSellerPOMaterialTransactions(pastSellerPOMaterialtransactiosRes.data)
    }

    const getProcmartStates = async () => {
        const response = await getCompanyBillAddrs({ companyIds: [pmCompanyDetails.companyId], statusIds: [1], paginator: false })
        if (response.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'Billing Address', detail: response.data.error, life: 3000 }))
        }
        setProcmartCompanyBillAddrs(response.data.data)

        const allStateIds = _.map(response.data.data, 'stateId')
        const filteredStates = _.filter(statesDetails, (state) => allStateIds.includes(state.stateId))
        setStatesData(filteredStates)
    }

    const getStockWarehouses = async (buyerPOItems) => {
        const materialIds = buyerPOItems?.map(eachBuyerPOItem => eachBuyerPOItem?.materialId)
        if (materialIds.length){
            setIsCreateSellerPOLoading(true)
            const stockWarehousesRes = await getMaterialsInStock({ materialIds: materialIds })
            if (stockWarehousesRes?.failure) {
                setIsCreateSellerPOLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Stock Warehouse", detail: stockWarehousesRes.data.error, life: 3000 }))
            }
            setStockMaterials(stockWarehousesParser(stockWarehousesRes?.data))
            // setIsCreateSellerPOLoading(false)
        }
    }

    const getSmartStockMoves = async (sellerReqs, sellerReqItems) => {
        const warehouseIdAndMaterialIdCombinations = _.compact(sellerReqItems.map(eachReqItem => {
            const relatedSellerReq = sellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === eachReqItem.sellerReqId)

            if (relatedSellerReq?.companyId === relatedSellerReq?.pmCompanyId) {
                const relatedPMBranch = PMBranches.find(eachPMBranch => eachPMBranch.branchId === relatedSellerReq.branchId)
                if (relatedPMBranch) {
                    return `(${relatedPMBranch.warehouseId}, ${eachReqItem.materialId})`
                }
            }
            return null
        }))

        if (warehouseIdAndMaterialIdCombinations.length > 0) {
            // setIsCreateSellerPOLoading(true)
            const smartStockMovesRes = await getSmartStockMovesByWarehouseIdAndMaterialIdCombination({ warehouseIdAndMaterialIdCombinations })
            if (smartStockMovesRes?.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "smartStockMovesRes", detail: smartStockMovesRes.data.error, life: 3000 }))
            }
            
            const sortedSmartStockMoves = _.sortBy(smartStockMovesRes.data, "stockMoveId", "createdAt")
            // setSmartStockMoves(sortedSmartStockMoves)
            return sortedSmartStockMoves
        }
    }

    const handleBuyerPOSelection = (e) => {
        dispatch(setSelectedBuyerPODocNo(e.target.value))
    }

    const renderHeader = () => {
        return (
            <div className="flex flex-row justify-content-between">
                <p>Create Seller Purchase Order</p>
                <div className="col-5 flex flex-row justify-content-end align-items-center py-0">
                    <span style={{ fontSize: "13px", marginRight: "5px" }} >Buyer PO No: </span>
                    <span className=""><DropDownField options={buyerPOOptions} value={selectedBuyerPODocNo} optionLabel="formatedDocNo" optionValue="docNo" className="document-select-dropdown" onChange={(e) => handleBuyerPOSelection(e)} /></span>
                </div>
            </div>
        )
    }

    const handleOnHideDialog = () => {
        dispatch(setSelectedBuyerPODocNo(null))
        setDisplaySellerPOs([])
        setDisplaySellerPOItems([])
        setBuyerPOOptions([])
        setVisibleCreateSellerPO(false)
    }

    const getCentralAssignUserIdByCategoryId = (materialDetails) => {
        let categoryUsers = materialIdTeam.filter(user => user.accessType === "CATEGORY" && user.accessEntity === materialDetails.categoryId)

        if(categoryUsers.length){
            const randomNumber = Math.floor(Math.random() * (categoryUsers.length - 1))

            const updatedMaterialDetails = {...materialDetails, assigneeCentralUserId: categoryUsers[randomNumber].userId}
            return updatedMaterialDetails
        } else {
            return materialDetails
        }
    }

    const handleCheckMaterialsAreInMaterialSpecs = async (materialItems) => {
        setIsLoading(true)
        const checkMaterialsAreInMaterialSpecsResponse = await checkMaterialsAreInMaterialSpecs(materialItems)
        if (checkMaterialsAreInMaterialSpecsResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: checkMaterialsAreInMaterialSpecsResponse.data.error, life: 3000 }))
        }

        const responseData = checkMaterialsAreInMaterialSpecsResponse.data
        let materialIds = _.uniqBy(_.map(materialItems, "materialId"))

        if(responseData.length){
            if(!materialSpecsMatchesData.length){
                setMaterialSpecsMatchesData(responseData)
            }else{
                let updatedMaterialSpecsMatchesData = [...materialSpecsMatchesData]
                let relatedMaterialSpecsMatchesData = materialSpecsMatchesData.find(eachMaterial => materialIds.includes(eachMaterial.materialId))
                if(relatedMaterialSpecsMatchesData){
                    updatedMaterialSpecsMatchesData = materialSpecsMatchesData.map(eachMaterial => {
                        if(materialIds.includes(eachMaterial.materialId)){
                            return {...responseData[0]}
                        }
                        return eachMaterial
                    })
                }else{
                    updatedMaterialSpecsMatchesData = [...materialSpecsMatchesData, { ...responseData[0] }]
                }

                setMaterialSpecsMatchesData(updatedMaterialSpecsMatchesData)
            }
        }else{
            if(!materialSpecsMatchesData.length){
                setMaterialSpecsMatchesData([])
            }else{
                let relatedMaterialSpecsMatchesData = materialSpecsMatchesData.filter(eachMaterial => !materialIds.includes(eachMaterial.materialId))
                setMaterialSpecsMatchesData(relatedMaterialSpecsMatchesData)
            }
        }
        setIsLoading(false)
    }

    const handleRaisePriority = async (lowPriorityMaterials) => {
        const unSavedMaterials = allMaterialDetails.some(eachMaterial => eachMaterial.isEditable)
        if (unSavedMaterials) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please save all the material details!', life: 3000 })) 
        }

        const noCategoryMaterials = allMaterialDetails.some(eachMaterial => !eachMaterial.categoryId || eachMaterial.categoryId === 22 )
        if (noCategoryMaterials) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Category should be filled for all material items', life: 3000 })) 
        }

        const missingCategoryMaterial = allMaterialDetails.find(eachMaterial => !eachMaterial.categoryId)
        if(missingCategoryMaterial){
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter category for materialId ${missingCategoryMaterial.materialId}`, life: 3000 }))
        }
        
        if(!window.confirm("Please make sure all the material items category are correct?")){
            return false
        }

        if(materialSpecsMatchesData.length){
            setIsMaterialSpecsConfirmModalVisible(true)
        }else{
            submitRaisePriorityMaterials(lowPriorityMaterials)
        }
    }

    const submitRaisePriorityMaterials = async(lowPriorityMaterials) => {

        if (window.confirm('Do you want to raise priority for all materials to high?')) {
            setIsLoading(true)

            // const materialIds = lowPriorityMaterials.map(eachTempMat => eachTempMat.materialId)
            // const materialMasterTempRes = await updateMaterialMasterTempPriorityStatus({ materialIds: materialIds, priority: 1 })
            const materialIds = []
            const lowPrirorityTempMaterialItems = lowPriorityMaterials.map(eachTempMat => {
                materialIds.push(eachTempMat.materialId)

                if(!eachTempMat.assigneeCentralUserId){
                    let updatedMaterialDetail = getCentralAssignUserIdByCategoryId(eachTempMat)
                    return {...updatedMaterialDetail}
                }
                return eachTempMat
            })

            const materialMasterTempRes = await updateAssigneeCentralUserIdAndPriorityStatus({ tempMaterialItems: lowPrirorityTempMaterialItems })
            if (materialMasterTempRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "materialMasterTempRes", detail: materialMasterTempRes.data.error, life: 3000 }))
            }

            const updatedTempMaterialItems = tempMaterialItems.map(eachTempMaterial => {
                const relatedUpdatedMaterial = materialMasterTempRes.data.find(eachMaterial => eachMaterial.materialId === eachTempMaterial.materialId)
                if (relatedUpdatedMaterial) {
                    return { ...eachTempMaterial, priority: relatedUpdatedMaterial?.priortiy }
                }
                return eachTempMaterial
            })

            setTempMaterialItems(updatedTempMaterialItems)
            setIsMaterialSpecsConfirmModalVisible(false)
            setMaterialSpecsMatchesData([])
            setIsLoading(false)
            constructBuyerPOAndSellerReq(sellerReqData, buyerPOData, selectedReq, selectedBuyerPODocNo)

            dispatch(raiseToast({ severity: 'success', detail: `Material Id(s) ${materialIds.join(', ')} priority has raised to 1`, life: 3000 }))
        }
    }

    const handleUpdateMaterialStatus = async (materialId, status) => {
        const relatedMaterialStatus = materialEditStatus.some(materialStatus => {
            return parseInt(Object.keys(materialStatus)[0]) === materialId
        })

        let updatedMaterialStatues = [...materialEditStatus]
        if (!relatedMaterialStatus) {
            updatedMaterialStatues = [...updatedMaterialStatues, { [materialId]: status }]
        }
        else {
            updatedMaterialStatues = updatedMaterialStatues.map(eachMaterialStatus => {
                if (parseInt(Object.keys(eachMaterialStatus)[0]) === materialId) {
                    return { ...eachMaterialStatus, [materialId]: status }
                }
                return eachMaterialStatus
            })
        }

        setMaterialEditStatus(updatedMaterialStatues)
    }

    const renderMessageHTML = (tempMaterialItems, materialTeamNames, allMaterialDetails) => {
        let tempMaterialIds = tempMaterialItems.map(eachMaterial => {
            // if (eachMaterial.priority !== 1) {
            //     return eachMaterial.materialId
            // }
            return eachMaterial.materialId
        })
        tempMaterialIds = _.compact(tempMaterialIds)

        const lowPriorityMaterials = tempMaterialItems.filter(eachMaterial => eachMaterial.priority !== 1)
        const raisedOnDate = _.max(tempMaterialItems.map(eachMaterial => eachMaterial.createdAt))

        return (
            <div className="flex justify-content-between w-full">
                <div className="flex flex-column p-0">
                    <p className="p-0 m-0">Material ID{tempMaterialIds.length === 1 ? '' : 's'} <span className="font-semibold">{tempMaterialIds.join(", ")} </span>{tempMaterialIds.length === 1 ? 'is' : 'are'} not approved!</p>
                    <p className="p-0 m-0">Creating seller PO is only allowed for approved material IDs.</p>
                </div>
                <div className={lowPriorityMaterials?.length === 0 && `priority-tooltip`}>
                    <Button
                        severity="warning"
                        onClick={() => handleRaisePriority(lowPriorityMaterials, allMaterialDetails)}
                        loading={isLoading}
                        disabled={lowPriorityMaterials?.length === 0 || isCreateSellerPOLoading}
                        style={{width: '8.5rem', height: '2.6rem'}}
                        className="p-0"
                        permissions={[186]}
                    >
                        <div className="flex flex-column align-items-center w-full">
                            <p className="m-0" style={{fontSize: lowPriorityMaterials?.length === 0 ? '0.75em': null }}>{lowPriorityMaterials?.length > 0 ? "Raise Priority" : "Priority raised"}</p>
                            {lowPriorityMaterials?.length === 0 && <span style={{fontSize: '0.95em'}}>{getDateTimeString(raisedOnDate, 'Do MMM HH:mm')}</span>}
                            {/* {lowPriorityMaterials?.length === 0 && <span style={{fontSize: '0.65em'}}>raised on: {getDateTimeString(raisedOnDate, 'Do MMMM YYYY HH:mm')}</span>} */}
                        </div>
                    </Button>
                </div>
                {/* <Tooltip target={`.priority-tooltip`} position="top">
                    <p className="m-0">Priority was already raised to high. If issue was not resolved yet,</p>
                    <p className="m-0">contact persons: {materialTeamNames ? materialTeamNames?.join(", ") : ''}</p>
                </Tooltip> */}
            </div>
        )
    }

    const handleUseStock = (buyerPOItemId) => {
        const relatedBuyerPOItem = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem?.buyerPOItemId === buyerPOItemId)
        setSelectedBuyerPOItem(relatedBuyerPOItem)
        setIsStockVisible(true)
    }

    const handleAddStock = (stockWarehouseId, materialId) => {
        const relatedStockWarehouse = stockMaterials?.find(eachStockMaterial => eachStockMaterial?.stockWarehouseId === stockWarehouseId && eachStockMaterial?.materialId === materialId)
        const relatedSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq?.userId === relatedStockWarehouse?.warehouseManagerId && eachSellerReq?.branchId === relatedStockWarehouse?.branchId)
        const relatedSellerReqItem = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.sellerReqId === relatedSellerReq?.sellerReqId && eachSellerReqItem?.materialId === materialId && eachSellerReqItem?.statusId === 1)

        if (relatedSellerReqItem?.sellerReqId) {
            const accept = () => {
                setOldSellerReqItems([relatedSellerReqItem])
                setSelectedStockWarehouse(relatedStockWarehouse)
                setIsStockDetailsVisible(true)
            }

            const reject = () => {
                setIsStockVisible(false)
            }

            confirmDialog({
                message: 'This seller req item is already present, adding again will make previous seller req item expire. Do you want to proceed?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                defaultFocus: 'accept',
                accept,
                reject
            })
        } else {
            setSelectedStockWarehouse(relatedStockWarehouse)
            setIsStockDetailsVisible(true)
        }
    }

    const handleQuotChange = (e, availableQty) => {
        if (e.target.name === "quotQty") {
            let qtyToastText = ''
            let minRestrictedQty = availableQty
            if (availableQty > selectedBuyerPOItem.bPOQty) {
                minRestrictedQty = selectedBuyerPOItem.bPOQty
                qtyToastText = `Quantity can not exceed buyer PO qty: ${selectedBuyerPOItem.bPOQty}`
            } else {
                qtyToastText = `Available Qty: ${availableQty} Only`
            }

            if (parseFloat(e.target.value) > minRestrictedQty) {
                setQuoteDetails(prevState => ({ ...prevState, [e.target.name]: round(minRestrictedQty) }))
                return dispatch(raiseToast({ severity: 'warn', detail: qtyToastText, life: 3000 }))
            }
            else {
                setQuoteDetails(prevState => ({ ...prevState, [e.target.name]: e.target.value }))
            }
        }
        else {
            setQuoteDetails(prevState => ({ ...prevState, [e.target.name]: e.target.value }))
        }
    }

    const handleHSNCodeOnBlur = (e) => {
        let HSNCodeDetails = []
        if (e.target.value.length > 4) {
            HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === parseFloat(e.target.value))

            if (HSNCodeDetails.length === 0) {
                dispatch(raiseToast({ severity: 'error', detail: 'Invalid HSN Code', life: 3000 }))
            }
        }
    }

    const handleOnAddQuote = async () => {
        let paymentTerms = null
        if (selectedStockWarehouse?.branchPaymentTerms) {
            paymentTerms = selectedStockWarehouse?.branchPaymentTerms
        } else {
            paymentTerms = selectedStockWarehouse?.companyPaymentTerms
        }
        if (paymentTerms) {
            if (typeof (paymentTerms) === "string") {
                paymentTerms = JSON.parse(paymentTerms)
            }
            else if (typeof (paymentTerms) === "object") {
                paymentTerms = paymentTerms
            }
        }
        const isURD = selectedStockWarehouse?.gstinCode ? false : true
        let sellerReq = {
            buyerReqId: selectedReq.buyerReqId,
            companyId: selectedStockWarehouse?.companyId,
            branchId: selectedStockWarehouse?.branchId,
            userId: selectedStockWarehouse?.warehouseManagerId,
            statusId: 1,
            pmCompanyId: selectedReq.pmCompanyId,
            pmBranchId: selectedReq.pmBranchId,
            emailId: selectedStockWarehouse?.emailId,
            billAddrId: selectedReq.billAddrId,
            docNo: selectedReq.docNo,
            fileNo: selectedReq.fileNo,
            isURD: isURD,
            paymentTerms: paymentTerms,
            isNew: true,
            createdBy: userDetails.userId,
            updatedBy: userDetails.userId
        }

        let relatedSellerReqItemMaterial = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.materialId === selectedBuyerPOItem?.materialId)
        const { unitPrice, GSTRate } = calculateStockGSTAndPrice(quoteDetails.quotQty, selectedStockWarehouse?.smartStockMoves)
        let quotTotalAmountBeforeTax = parseFloat(quoteDetails.quotQty) * unitPrice
        let quotTotalAmountWithTax = quotTotalAmountBeforeTax + parseFloat(quotTotalAmountBeforeTax * 0.01 * GSTRate)
        let sellerReqItem = {
            buyerReqItemId: selectedBuyerPOItem?.buyerReqItemId,
            buyerReqId: selectedReq.buyerReqId,
            materialId: selectedBuyerPOItem?.materialId,
            qty: relatedSellerReqItemMaterial?.qty,
            quotQty: quoteDetails.quotQty,
            quotHSNCode: quoteDetails.quotHSNCode,
            quotGSTRate: GSTRate,
            smartGSTRate: GSTRate,
            quotDiscountRate: 0,
            quotListPrice: unitPrice,
            quotUnitPrice: unitPrice,
            quotLeadTime: quoteDetails.quotLeadTime,
            quotTotalAmountBeforeTax: round(quotTotalAmountBeforeTax),
            quotTotalAmountWithTax: round(quotTotalAmountWithTax),
            quotLogisticsBeforeTax: 0,
            quotLogisticsGSTRate: 0,
            quotLogisticsWithTax: 0,
            pmCompanyId: selectedReq.pmCompanyId,
            shipAddrId: relatedSellerReqItemMaterial?.shipAddrId,
            isNew: true,
            createdBy: userDetails.userId,
            updatedBy: userDetails.userId
        }

        if(PMCompanyConfig.defaultHSNCode){
            sellerReqItem.quotHSNCode = PMCompanyConfig.defaultHSNCode
        }

        const updatedOldSellerReqItems = oldSellerReqItems?.map(eachSellerReqItem => {
            return { ...eachSellerReqItem, statusId: 2 }
        })
        let data = {
            sellerReq: sellerReq,
            sellerReqItems: [sellerReqItem, ...updatedOldSellerReqItems],
            prevSellerReqItems: initialSellerReqItems,
            expireOldSellerReqItem: oldSellerReqItems.length > 0 ? true : false
        }

        if (!sellerReqItem.quotQty) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter Quote Qty', life: 3000 }))
        }
        if (!sellerReqItem.quotLeadTime) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter Quote Lead Time', life: 3000 }))
        }
        if (!sellerReqItem.quotHSNCode) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter Quote HSNCode', life: 3000 }))
        }
        if (sellerReqItem.quotHSNCode && sellerReqItem.quotHSNCode.toString().length < 6) {
            return dispatch(raiseToast({ severity: 'error', detail: 'HSNCode Should contain atleast 6 numbers.', life: 3000 }))
        }
        const relatedHSNCode = HSNMasterData.find(eachHSN => eachHSN.HSNCode === parseInt(sellerReqItem.quotHSNCode))
        if (!relatedHSNCode) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter Valid HSN Code!`, life: 3000 }))
        }
        // if (!quoteDetails?.quotGSTRate && quoteDetails?.quotGSTRate < 0) {
        //     return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter Quote GSTRate', life: 3000 }))
        // }

        if (window.confirm("Are you sure you want to continue...?")) {
            setIsLoading(true)
            const response = await insertUseFromStockSellerReq(data)
            if (response.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Seller Req', detail: response?.data?.error, life: 3000 }))
            }
            setQuoteDetails({})

            const sellerDetailsRes = await getSellerDetailsBySellerReqs({ sellerReqs: [response?.sellerReq] })
            if (sellerDetailsRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Sellers Names', detail: sellerDetailsRes.data.error, life: 3000 }))
            }

            const newSmartStockMoves = await getSmartStockMoves([response.sellerReq], response.sellerReqItems)
            let updatedSmartStockMoves = []
            if(smartStockMoves){
                updatedSmartStockMoves = [...smartStockMoves]
            }
            setSmartStockMoves([...updatedSmartStockMoves, ...newSmartStockMoves])

            let updatedSellerReqs = [...sellerReqs, response.sellerReq]
            let updatedSellerReqItems = [...sellerReqItems, ...response.sellerReqItems]
            let updatedInitialSellerReqItems = [...initialSellerReqItems]

            const deletedSelReqItem = updatedSellerReqItems.find(eachSelReqItem => eachSelReqItem.statusId === 2)
            if (deletedSelReqItem) {
                updatedSellerReqItems = updatedSellerReqItems.filter(eachSelReqItem => eachSelReqItem.sellerReqItemId !== deletedSelReqItem.sellerReqItemId)
            }
            updatedSellerReqItems = updatedSellerReqItems.map(eachReqItem => {
                return {...eachReqItem, smartUnitPrice: eachReqItem.quotUnitPrice, smartGSTRate: eachReqItem.quotGSTRate}
            })

            if (deletedSelReqItem) {
                updatedInitialSellerReqItems = updatedInitialSellerReqItems.filter(eachSelReqItem => eachSelReqItem.sellerReqItemId !== deletedSelReqItem.sellerReqItemId)
            }
            updatedInitialSellerReqItems = [...updatedInitialSellerReqItems, ...response.sellerReqItems]

            let updatedSellerCompanyDetails = [...sellerCompanyDetails, ...sellerDetailsRes?.data]

            dispatch(raiseToast({ severity: 'success', detail: 'Seller req added Successfully', life: 3000 }))

            setSellerReqs(updatedSellerReqs)
            setSellerReqItems(updatedSellerReqItems)
            setInitialSellerReqItems(updatedInitialSellerReqItems)
            setSellerCompanyDetails(updatedSellerCompanyDetails)
            setDisplaySellerPOs([])
            setDisplaySellerPOItems([])
            setIsStockDetailsVisible(false)
            setIsStockVisible(false)
            setIsLoading(false)
        }
    }

    const getPartialSpecsApprovalInstances = async (tempMaterialIds) => {
        setTempMaterialIds(tempMaterialIds)
        const approverInstancesRes = await getApprovalInstances({ materialIds: tempMaterialIds })
        if (approverInstancesRes.failure) {
            setIsCreateSellerPOLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: "Approval Instance", details: approverInstancesRes.data.error, life: 3000 }))
        }

        setApprovalInstances(approverInstancesRes.data.data)
    }

    let relatedStockMaterials = []
    if (selectedBuyerPOItem?.materialId) {
        relatedStockMaterials = stockMaterials?.filter(eachStockMaterial => eachStockMaterial?.materialId === selectedBuyerPOItem?.materialId)
    }
    
    const lowPriorityMaterials = allMaterialDetails.filter(eachMaterial => eachMaterial.materialId.toString().length >= 7 && eachMaterial.priority !== 1)

    return (
        <Dialog className="create-seller-po-dialog" style={{ height: '90vh' }} header={renderHeader} visible={visibleCreateSellerPO} onHide={() => handleOnHideDialog()} >
            <>
                {
                    selectedReq &&
                    <p className="m-0 flex align-items-center">
                        <span style={{ fontWeight: "bold" }} className="m-0"> Requirement No: </span> <span className="ml-1">{selectedReq["docNo"]}<CopyToClipboard text={selectedReq["docNo"]} /></span>
                        <span className="ml-5" style={{ fontWeight: "bold" }}> Buyer: </span> <span className="ml-1">{selectedReq["company.companyName"]} - {selectedReq["buyerCompanyBranch.branchName"]} - {`${selectedReq["buyer.firstName"]} ${selectedReq["buyer.lastName"] ? selectedReq["buyer.lastName"] : ''}`}</span>
                    </p>
                }
                <>
                    {/* {
                        <Messages ref={tempMaterialIDsMsgs} className="m-0" />
                    } */}
                    {visibleMaterialMessages &&
                        <div className="p-card mb-1 message-container mt-1 flex flex-row justify-content-between py-2 bg-red-100">
                            {
                                renderMessageHTML(tempMaterialItems, materialTeamNames, allMaterialDetails)
                            }
                        </div>
                    }
                </>
                {
                    selectedBuyerPODocNo ?
                        isCreateSellerPOLoading ?

                            <div className="flex justify-content-center align-items-center h-full">
                                <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={true} />
                            </div>
                            :
                            <>
                                <div className="">
                                    {buyerPOItems?.length === 0 ?
                                        <p className="punch-msg" style={{ textAlign: "center", fontWeight: "bold" }}>No active po punches found to create seller po</p> :
                                        <>
                                            {buyerPOItems.map(eachPOItem => {
                                                const materialDetails = allMaterialDetails.find(eachMaterialCode => {
                                                    return parseFloat(eachMaterialCode.materialId) === parseFloat(eachPOItem.materialId)
                                                })
                                                const relatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.buyerReqItemId === eachPOItem.buyerReqItemId && eachSellerReqItem.statusId === 1)
                                                relatedSellerReqItems.sort((a, b) => a.quotUnitPrice - b.quotUnitPrice)
                                                const partialSpecsApproval = materialMasterApprovals.find(eachApproval => eachApproval.approvalTypeId === 15)  // APPROVAL_CHANGE find by typeId

                                                const relatedNonRoutedSellerPOInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPOInfo => eachNonRoutedSellerPOInfo.companyId === sellerCompanyDetails.companyId)
                                               
                                                return (
                                                    <ProductsListItems
                                                        key={eachPOItem.buyerPOItemId}
                                                        buyerPO={buyerPO}
                                                        buyerPOItem={eachPOItem}
                                                        sellerCompanyDetails={sellerCompanyDetails}
                                                        materialDetails={materialDetails}
                                                        sellerReqs={sellerReqs}
                                                        sellerReqItems={sellerReqItems}
                                                        relatedSellerReqItems={relatedSellerReqItems}
                                                        setSellerReqItems={setSellerReqItems}
                                                        buyerQuoteItems={buyerQuoteItems}
                                                        displaySellerPOs={displaySellerPOs}
                                                        setDisplaySellerPOs={setDisplaySellerPOs}
                                                        displaySellerPOItems={displaySellerPOItems}
                                                        setDisplaySellerPOItems={setDisplaySellerPOItems}
                                                        allMaterialDetails={allMaterialDetails}
                                                        setAllMaterialDetails={setAllMaterialDetails}
                                                        materialCategories={materialCategories}
                                                        brandData={brandData}
                                                        procmartCompanyBillAddrs={procmartCompanyBillAddrs}
                                                        statesData={statesData}
                                                        companyWarehouses={companyWarehouses}
                                                        handleUseStock={handleUseStock}
                                                        stockMaterials={stockMaterials}
                                                        lowPriorityMaterials={lowPriorityMaterials}
                                                        initialMaterialDetails={initialMaterialDetails}
                                                        setIsLoading={setIsLoading}
                                                        handleUpdateMaterialStatus={handleUpdateMaterialStatus}
                                                        materialIdTeam={materialIdTeam}
                                                        initialSellerReqItems={initialSellerReqItems}
                                                        smartStockMoves={smartStockMoves}
                                                        PMBranches={PMBranches}
                                                        partialSpecsApproval={partialSpecsApproval}
                                                        approvalInstances={approvalInstances}
                                                        buyerPOPunchItems={buyerPOPunchItems}
                                                        buyerReq={selectedReq}
                                                        tempMaterialItems={tempMaterialItems}
                                                        materialSpecsMatchesData={materialSpecsMatchesData}
                                                        setMaterialSpecsMatchesData={setMaterialSpecsMatchesData}
                                                        handleCheckMaterialsAreInMaterialSpecs={handleCheckMaterialsAreInMaterialSpecs}
                                                        setTempMaterialItems={setTempMaterialItems}
                                                        getPartialSpecsApprovalInstances={getPartialSpecsApprovalInstances}
                                                        pastSellerPOMaterialTransactions={pastSellerPOMaterialTransactions}
                                                        PMCompanyConfig={PMCompanyConfig}
                                                        pastSellerPOsInfo={pastSellerPOsInfo}
                                                        nonRoutedSellerPOsInfo={relatedNonRoutedSellerPOInfo}
                                                        approvals={approvals}
                                                    />
                                                )
                                            })}
                                        </>
                                    }
                                </div>
                                <div>
                                    {
                                        displaySellerPOs?.map(eachSellerPO => {
                                            const relatedDisplaySellerPOItems = displaySellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.displaySellerPOId === eachSellerPO.displaySellerPOId)
                                            const relatedSellerCompanyDetails = sellerCompanyDetails.find(eachSellerName => eachSellerName.sellerReqId === eachSellerPO.sellerReqId)
                                            const relatedPastSellerPOs = pastSellerPOsInfo.find(eachPastSellerPO => eachPastSellerPO.companyId === relatedSellerCompanyDetails.companyId)
                                            const relatedNonRoutedSellerPOInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPO => eachNonRoutedSellerPO.companyId === eachSellerPO.companyId)

                                            return (
                                                <DisplaySellerPO
                                                    key={`displaySellerPO-${eachSellerPO.displaySellerPOId}`}
                                                    allMaterialDetails={allMaterialDetails}
                                                    displaySellerPO={eachSellerPO}
                                                    displaySellerPOItems={relatedDisplaySellerPOItems}
                                                    relatedSellerCompanyDetails={relatedSellerCompanyDetails}
                                                    setIsPageLoading={setIsPageLoading}
                                                    allDisplaySellerPOs={displaySellerPOs}
                                                    setDisplaySellerPOs={setDisplaySellerPOs}
                                                    HSNMasterData={HSNMasterData}
                                                    setDisplaySellerPOItems={setDisplaySellerPOItems}
                                                    companyCreditPeriods={companyCreditPeriods}
                                                    incoTerms={incoTerms}
                                                    buyerShipAddrs={buyerShipAddrs}
                                                    procmartShipAddrs={procmartShipAddrs}
                                                    procmartCompanyBillAddrs={procmartCompanyBillAddrs}
                                                    relatedPMStates={statesData}
                                                    companyWarehouses={companyWarehouses}
                                                    handleUseStock={handleUseStock}
                                                    stockMaterials={stockMaterials}
                                                    lowPriorityMaterials={lowPriorityMaterials}
                                                    initialMaterialDetails={initialMaterialDetails}
                                                    setIsLoading={setIsLoading}
                                                    handleUpdateMaterialStatus={handleUpdateMaterialStatus}
                                                    initialSellerReqItems={initialSellerReqItems}
                                                    selectedReq={selectedReq}
                                                    buyerQuoteItems={buyerQuoteItems}
                                                    tdsSections={tdsSections}
                                                    buyerPoCreatedAtDate={buyerPoCreatedAtDate}
                                                    setSellerCompanyDetails={setSellerCompanyDetails}
                                                    sellerCompanyDetails={sellerCompanyDetails}
                                                    approvals={approvals}
                                                    buyerReq={selectedReq}
                                                    buyerPOItems={buyerPOItems}
                                                    userDetails={userDetails}
                                                    pastSellerPOsInfo={relatedPastSellerPOs}
                                                    nonRoutedSellerPOsInfo={relatedNonRoutedSellerPOInfo}
                                                    buyerPO={buyerPO}
                                                    sellerReqs={sellerReqs}
                                                    setSellerReqs={setSellerReqs}
                                                    sellerReqItems={sellerReqItems}
                                                    setSellerReqItems={setSellerReqItems}
                                                    materialMandatoryUseFromStock={materialMandatoryUseFromStock}
                                                    prevSellerPOs={prevSellerPOs}
                                                    sellerBankAccounts={sellerBankAccounts}
                                                    companyCertificates={companyCertificates}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </>
                        : null
                }
                <Dialog header="Stock Material" visible={isStockVisible} style={{ width: '55vw', height: '40vh' }} onHide={() => setIsStockVisible(false)}>
                    <>
                        {
                            isStockLoading ? (
                                <div className="flex flex-column justify-content-between align-items-center">
                                    <Oval
                                        height={45}
                                        width={45}
                                        color="#00baac"
                                        visible={true}
                                        ariaLabel='oval-loading'
                                        secondaryColor="#a4a7a6"
                                    />
                                </div>
                            ) : (

                                relatedStockMaterials?.length === 0 ? <p className="text-center">Selected material is not present in the stock.</p> :
                                    <div className="p-card">
                                        {
                                            relatedStockMaterials?.map(eachMaterial => {
                                                let name = getFullName(eachMaterial?.firstName, eachMaterial?.lastName)
                                                const { unitPrice } = calculateStockGSTAndPrice(eachMaterial.smartStock, eachMaterial.smartStockMoves)

                                                return (
                                                    <div key={`stockMaterial-${eachMaterial.stockWarehouseId}`} className="seller-company-collection flex flex-column">
                                                        <div className="flex flex-row justify-content-between p-2 border-bottom-1 border-300">
                                                            <div> <p> {eachMaterial.materialId} | Stock Qty : {eachMaterial?.smartStock} | UnitPrice: {unitPrice}* | Seller : {name}</p></div>
                                                            <div className="ml-2"><Button label="Add" style={{ backgroundColor: "#26a69a" }} onClick={() => handleAddStock(eachMaterial?.stockWarehouseId, eachMaterial?.materialId)} /></div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                            )
                        }
                    </>
                </Dialog>
                <Dialog header="Stock Details" visible={isStockDetailsVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => { setIsStockDetailsVisible(false); setQuoteDetails({}); setOldSellerReqItems([]) }}>
                    <div>
                        <div className="grid">
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name="quotQty" labelText="Q.Qty" value={quoteDetails?.quotQty} onChange={(e) => handleQuotChange(e, selectedStockWarehouse?.smartStock)} keyfilter='pnum' />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0" >
                                <TextInputField name="quotLeadTime" labelText='Q.LeadTime' value={quoteDetails?.quotLeadTime} onChange={(e) => handleQuotChange(e)} keyfilter='pnum' />
                            </div>
                            { !PMCompanyConfig.defaultHSNCode ? 
                                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0" >
                                    <TextInputField name="quotHSNCode" labelText='Q.HSNCode' value={quoteDetails?.quotHSNCode} onChange={(e) => handleQuotChange(e)} keyfilter='pnum' onBlur={(e) => handleHSNCodeOnBlur(e)} />
                                </div> : null
                            }
                            {/* <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <DropDownField name="quotGSTRate" labelText='Q.GST Rate' options={gstOptions} optionLabel="label" optionValue="value" value={quoteDetails?.quotGSTRate} onChange={(e) => handleQuotChange(e)} />
                            </div> */}
                        </div>
                        <div className="flex justify-content-end mt-4">
                            <Button className="h-2rem  p-2" label="Add" onClick={() => handleOnAddQuote()} />
                        </div>
                    </div>
                </Dialog>
                <Dialog header="" visible={isMaterialSpecsConfirmModalVisible} style={{ width: '30vw', minHeight: "30vh", }} onHide={() => setIsMaterialSpecsConfirmModalVisible(false)}>
                    <StructuredMaterialsConfirmModal 
                        tempMaterialItems={tempMaterialItems}
                        submitRaisePriorityMaterials={submitRaisePriorityMaterials}
                        setIsMaterialSpecsConfirmModalVisible={setIsMaterialSpecsConfirmModalVisible}
                    />
                </Dialog>
                <Loading visible={isLoading} />
            </>
        </Dialog>
    )
}

export default CreateSellerPO